<div class="dialog-container">
  <h3>Correos de atención</h3>
  <br>
  <div class="email-container">
    <label class="email-text">dom@penaflor.cl</label>
    <button mat-raised-button color="primary" class="copy-button" (click)="copyToClipboard('dom@penaflor.cl')">
      Copiar <mat-icon>file_copy</mat-icon>
    </button>
  </div>
</div>
